import type React from 'react';
import { Box, Card, Heading, List, TextButton } from '@zillow/constellation-10';
import pathsManifest from 'app/shared/utils/pathsManifest';

interface SEOFooterProps {
  areaName: string;
  zipcodesInCity: Array<{ name: string; resourceId: string }>;
  nearbyAreas: Array<{ name: string; resourceId: string }>;
}

const Link: React.FunctionComponent<
  React.PropsWithChildren<React.PropsWithChildren<{ name: string; resourceId: string }>>
> = (props) => {
  const { name, resourceId } = props;

  return (
    <List.Item css={{ listStyle: 'none', paddingBlock: 'none' }}>
      <TextButton asChild textStyle="body">
        <a href={`${pathsManifest.MarketTrendsPage}/${resourceId}/`}>{name}</a>
      </TextButton>
    </List.Item>
  );
};

const SEOFooter: React.FunctionComponent<React.PropsWithChildren<React.PropsWithChildren<SEOFooterProps>>> = (
  props,
) => {
  const { areaName, zipcodesInCity, nearbyAreas } = props;
  return (
    <Card css={{ marginTop: '600', paddingInline: '600', paddingBottom: '1200' }} tone="neutral">
      {nearbyAreas.length ? (
        <Box css={{ paddingTop: '400', marginBottom: '400' }}>
          <Heading level={4} textStyle="body-lg-bold" css={{ marginBottom: '800' }}>
            Nearby areas
          </Heading>
          <Box css={{ display: 'flex', flexFlow: 'row wrap', gap: '600' }}>
            {nearbyAreas.map(({ name, resourceId }) => (
              <Link key={resourceId} name={name} resourceId={resourceId} />
            ))}
          </Box>
        </Box>
      ) : null}
      {zipcodesInCity.length ? (
        <Box css={{ paddingTop: '400' }}>
          <Heading level={4} textStyle="body-lg-bold" css={{ marginBottom: '800' }}>
            Zip codes in {areaName}
          </Heading>
          <Box css={{ display: 'flex', flexFlow: 'row wrap', gap: '600' }}>
            {zipcodesInCity.map(({ name, resourceId }) => (
              <Link key={resourceId} name={name} resourceId={resourceId} />
            ))}
          </Box>
        </Box>
      ) : null}
    </Card>
  );
};

export default SEOFooter;
